import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { pagePath } from '../utils/consts/pagePath';

const ContractTemplatesPage = lazy(
  () => import('../../view/pages/ContractTemplatesPage'),
);

export const contractTemplateRoutes: RouteObject = {
  path: pagePath.contractTemplate.list,
  children: [
    {
      index: true,
      element: <ContractTemplatesPage />,
    },
  ],
};
